import React from 'react';

export default function AudioPlayIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66699 4L25.3337 16L6.66699 28V4Z" fill="#FECB04" />
    </svg>
  );
}
